import React from "react";
import Logo from "../../assets/images/logocdsmais.svg";

import * as S from "./styles.js";

const LoginContainer = ({ children }) => {
  return (
    <S.Wrapper id={"page-content"}>
      <div className="logo">
        <img src={Logo} alt={"Logotipo Casa do Saber +"} />
      </div>
      {children}
    </S.Wrapper>
  );
};

export default LoginContainer;
